import { supabase } from '@/integrations/supabase/client';

/**
 * Log a consent event to the immutable consent_records table (GDPR Art. 7).
 */
export async function logConsent(params: {
  userId: string;
  userType: 'client' | 'practitioner';
  consentType: string;
  consentVersion: string;
  action: 'granted' | 'revoked';
  metadata?: Record<string, unknown>;
}) {
  try {
    await (supabase.from('consent_records' as any).insert({
      user_id: params.userId,
      user_type: params.userType,
      consent_type: params.consentType,
      consent_version: params.consentVersion,
      action: params.action,
      ip_address: null, // Could be captured server-side for better accuracy
      user_agent: navigator.userAgent,
      metadata: params.metadata ?? {},
    }));
  } catch (err) {
    console.error('Failed to log consent record:', err);
  }
}

/**
 * Log a data processing activity to the immutable data_processing_log table (GDPR Art. 30).
 */
export async function logDataProcessing(params: {
  actorId: string;
  actorType: 'client' | 'practitioner' | 'admin' | 'system';
  action: 'create' | 'access' | 'export' | 'delete' | 'anonymize';
  resourceType: string;
  resourceId?: string;
  resourceCount?: number;
  details?: string;
}) {
  try {
    await (supabase.from('data_processing_log' as any).insert({
      actor_id: params.actorId,
      actor_type: params.actorType,
      action: params.action,
      resource_type: params.resourceType,
      resource_id: params.resourceId ?? null,
      resource_count: params.resourceCount ?? null,
      details: params.details ?? null,
    }));
  } catch (err) {
    console.error('Failed to log data processing activity:', err);
  }
}
